import MoneyInput from 'common/components/moneyInput/MoneyInput';
import { Col, Row } from 'react-bootstrap';
import { BudgetLineParameterDto } from 'api/budgets/models/BudgetLineParameterDto';
import { useContext } from 'react';
import { LinesDataProvider } from '../../../../LinesDataProvider';
import ExpressionSystem from 'common/components/expressionButton/ExpressionSystem';
import { getExpressionParameters } from '../../../../utils';
import { BudgetLineDto } from 'api/budgets/models/BudgetDto';

interface Props {
    parameter: BudgetLineParameterDto;
    line: BudgetLineDto;
    disabled: boolean;
    onChange: (parameter: Partial<BudgetLineParameterDto>, calculateTotals: boolean) => void;
}

function ParameterNumber({ parameter, line, disabled, onChange }: Props): JSX.Element | null {
    const { units } = useContext(LinesDataProvider);
    const unitPrefix = units.find(x => x.id === parameter.number?.unitId)?.symbol;

    return (
        <div>
            <Row>
                <Col xs={12} sm={4}>
                    <MoneyInput
                        value={parameter.number?.number ?? null}
                        onBlur={(v) => {
                            onChange({
                                number: {
                                    ...(parameter.number ?? {}),
                                    number: v ?? 0,
                                    numberExpression: v !== parameter.number?.number ? null : parameter.number?.numberExpression
                                }
                            }, false);
                        }}
                        disabled={disabled}
                        hideUnitsDrop={!unitPrefix}
                        unitPrefix={unitPrefix}
                        expressionButton={{
                            title: ExpressionSystem.formatParameterName([parameter.parameterName ?? '']),
                            value: parameter.number?.numberExpression ?? '',
                            loadParameters: () => getExpressionParameters(line.key),
                            onChange: (expr, value) => onChange({ number: { ...(parameter.number ?? {}), number: value ?? 0, numberExpression: expr } }, false)
                        }}
                    />
                </Col>
            </Row>
        </div>
    );
}

export default ParameterNumber;
